import React, { CSSProperties } from 'react';

interface PropsType {
  style?: CSSProperties;
  color?: string;
}

const SvgIconItalic: React.FC<PropsType> = ({ color, style }) => {
  const iconFillColor = color || '#292929';
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
    >
      <path
        d='M6.29804 18.625C6.04504 18.625 5.83112 18.5376 5.65629 18.3628C5.48162 18.1878 5.39429 17.9736 5.39429 17.7203C5.39429 17.4671 5.48162 17.2533 5.65629 17.0787C5.83112 16.9044 6.04504 16.8173 6.29804 16.8173H9.21154L12.452 7.18275H9.53854C9.28554 7.18275 9.07162 7.09525 8.89679 6.92025C8.72212 6.74542 8.63479 6.53133 8.63479 6.278C8.63479 6.02467 8.72212 5.81083 8.89679 5.6365C9.07162 5.46217 9.28554 5.375 9.53854 5.375H16.8848C17.1378 5.375 17.3516 5.46242 17.5263 5.63725C17.7011 5.81225 17.7885 6.02642 17.7885 6.27975C17.7885 6.53292 17.7011 6.74675 17.5263 6.92125C17.3516 7.09558 17.1378 7.18275 16.8848 7.18275H14.2788L11.0385 16.8173H13.6443C13.8973 16.8173 14.1112 16.9047 14.286 17.0798C14.4607 17.2546 14.548 17.4687 14.548 17.722C14.548 17.9753 14.4607 18.1892 14.286 18.3635C14.1112 18.5378 13.8973 18.625 13.6443 18.625H6.29804Z'
        fill={iconFillColor}
      />
    </svg>
  );
};

export default SvgIconItalic;
